/* eslint-disable @typescript-eslint/no-require-imports */
import type { FC, PropsWithChildren } from "react";

import CustomPlatform from "$src/core/utils/platform/platform";

export default CustomPlatform.select<() => FC<PropsWithChildren>>({
  tv: () => require("./PortalBoundary.tv").default,
  default: () => require("./PortalBoundary").default,
})();
